const actions = {
	GET_WRITE_ESSAY: 'GET_WRITE_ESSAY',
	GET_WRITE_ESSAY_SUCCESS: 'GET_WRITE_ESSAY_SUCCESS',

	CREATE_NEW_QUESTION_WRITE_ESSAY: 'CREATE_NEW_QUESTION_WRITE_ESSAY',
	CREATE_NEW_QUESTION_WRITE_ESSAY_SUCCESS: 'CREATE_NEW_QUESTION_WRITE_ESSAY_SUCCESS',

	DELETE_WRITE_ESSAY: 'DELETE_WRITE_ESSAY',
	DELETE_WRITE_ESSAY_SUCCESS: 'DELETE_WRITE_ESSAY_SUCCESS',

	GET_WRITE_ESSAY_DETAIL: 'GET_WRITE_ESSAY_DETAIL',
	GET_WRITE_ESSAY_DETAIL_SUCCESS: 'GET_WRITE_ESSAY_DETAIL_SUCCESS',

	UPDATE_WRITE_ESSAY_DETAIL: 'UPDATE_WRITE_ESSAY_DETAIL',
	UPDATE_WRITE_ESSAY_DETAIL_SUCCESS: 'UPDATE_WRITE_ESSAY_DETAIL_SUCCESS',

	WRITING_LOADING_FALSE: 'WRITING_LOADING_FALSE',
	//#region CRUD

	getWriteEssay: (model) => ({
		type: actions.GET_WRITE_ESSAY,
		payload: { model },
	}),

	createQuesWriteEssay: (body, cbSuccess, cbError) => ({
		type: actions.CREATE_NEW_QUESTION_WRITE_ESSAY,
		payload: { body },
		cbSuccess,
		cbError,
	}),

	getWriteEssayDetail: (id) => ({
		type: actions.GET_WRITE_ESSAY_DETAIL,
		payload: { id },
	}),

	updateWriteEssayDetail: (model, cbSuccess, cbError) => ({
		type: actions.UPDATE_WRITE_ESSAY_DETAIL,
		payload: { model },
		cbSuccess,
		cbError,
	}),

	deleteWriteEssay: (id, cbSuccess, cbError) => ({
		type: actions.DELETE_WRITE_ESSAY,
		payload: { id },
		cbSuccess,
		cbError,
	}),
};

export default actions;
